import { DaVinciEvents } from "./DaVinciEvents.js";

/**
 * [Auto Save Module]
 * Handles 3-second debounce logic for silent auto-saving.
 * Keeps the main Editor page clean.
 */
export const DaVinciAutoSave = {
    init(saveCallback, interval = 3000) {
        let timer = null;

        const trigger = () => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                console.log("[AutoSave] Triggering...");
                saveCallback();
            }, interval);
        };

        // Listen to changes
        const unsubUpdate = DaVinciEvents.on(DaVinciEvents.ON_BLOCK_UPDATE, trigger);
        const unsubAdd = DaVinciEvents.on(DaVinciEvents.ON_BLOCK_ADD, trigger);
        const unsubDelete = DaVinciEvents.on(DaVinciEvents.ON_BLOCK_DELETE, trigger);
        const unsubMove = DaVinciEvents.on(DaVinciEvents.ON_BLOCK_MOVE, trigger);
        // Also listen for title/metadata changes
        const unsubState = DaVinciEvents.on(DaVinciEvents.ON_STATE_CHANGE, ({ prop }) => {
            if (prop === 'title' || prop === 'metadata') trigger();
        });

        console.log("[AutoSave] Initialized (3s)");

        // Return cleanup function
        return () => {
            if (timer) clearTimeout(timer);
            unsubUpdate();
            unsubAdd();
            unsubDelete();
            unsubMove();
            unsubState();
            console.log("[AutoSave] Destroyed");
        };
    }
};
